import React from 'react';
import { useSelector } from 'react-redux';
import IntroComponent from '../components';
import ROUTERS from "../../../commons/constans/router";
import { Navigate  } from "react-router-dom";

const IntroPageContainer = () => {
  console.log('IntroPageContainer');
  return <Navigate to={ROUTERS.HOME} />
  // return <IntroComponent
  // />;
};

export default IntroPageContainer;
